import { render, staticRenderFns } from "./BilletExcelFileDetail.vue?vue&type=template&id=577e6f36"
import script from "./BilletExcelFileDetail.vue?vue&type=script&lang=js"
export * from "./BilletExcelFileDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports